import { render, staticRenderFns } from "./projectTransaction.vue?vue&type=template&id=5f1530c2&"
import script from "./projectTransaction.vue?vue&type=script&lang=js&"
export * from "./projectTransaction.vue?vue&type=script&lang=js&"
import style0 from "./projectTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports